import React from 'react';
import { Category } from 'module/Model/Categories';
import { CategoryLinkWrapper, NextTextWrapper } from './NextPosts.s';
import {
  createPluralized,
  LangProvider,
  LocalizedText,
  NavProvider
  } from 'module/View/Common';
import { createPureComponent } from 'module/Common';
import { Localized } from 'module/Model/Localized';
import { RouteType } from 'module/Model/Routes';

const CategoriesPluralized = createPluralized<Category>();

type NextTextProps = {
  single: Localized<string>;
  multiple: Localized<string>;
  categories: Array<Category>;
};

export const NextCategoriesLinks = createPureComponent<NextTextProps>(
  'NextCategoriesLinks',
  ({ single, multiple, categories }) => (
    <NextTextWrapper>
      <CategoriesPluralized
        content={categories}
        renderSingle={cat => (
          <NavProvider
            routeType={RouteType.Category}
            routeId={Category.getId(cat)}
            key={Category.getId(cat)}
            requestNavigation={true}
          >
            {params => (
              <CategoryLinkWrapper {...params.getAnchorProps()}>
                <LangProvider>
                  {lang => Localized.get(single, lang) + Localized.get(Category.getName(cat), lang)}
                </LangProvider>
              </CategoryLinkWrapper>
            )}
          </NavProvider>
        )}
        renderMultiple={cats => (
          <>
            <LangProvider>{lang => Localized.get(multiple, lang)}</LangProvider>
            {cats
              .map(cat => (
                <NavProvider
                  routeType={RouteType.Category}
                  routeId={Category.getId(cat)}
                  key={Category.getId(cat)}
                  requestNavigation={true}
                >
                  {params => (
                    <CategoryLinkWrapper {...params.getAnchorProps()}>
                      <LocalizedText content={Category.getName(cat)} />
                    </CategoryLinkWrapper>
                  )}
                </NavProvider>
              ))
              .reduce<Array<any>>((acc, item, index, arr) => {
                acc.push(item);
                if (index < arr.length - 1) {
                  acc.push(', ');
                }
                return acc;
              }, [])}
          </>
        )}
      />
    </NextTextWrapper>
  )
);



// WEBPACK FOOTER //
// ./src/module/View/NextPosts/NextCategoriesLinks.tsx